import { useEffect, useState } from "react";

export default function BannerSlider({ banners }) {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (banners.length < 2) return;
    const id = setInterval(() => setCurrent(i => (i + 1) % banners.length), 4000);
    return () => clearInterval(id);
  }, [banners.length]);

  if (!banners || banners.length === 0) return null;

  const banner = banners[current];

  const handleClick = () => {
    if (banner.linkUrl) window.open(banner.linkUrl, "_blank", "noreferrer");
  };

  return (
    <div style={{ marginBottom: 20, borderRadius: 12, overflow: "hidden", position: "relative", background: "#f5f4f1" }}>
      <div
        onClick={handleClick}
        style={{
          cursor: banner.linkUrl ? "pointer" : "default",
          width: "100%",
          aspectRatio: "3/1",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {banner.imageUrl ? (
          <img
            src={banner.imageUrl}
            alt={banner.title || ""}
            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", transition: "opacity 0.4s" }}
          />
        ) : (
          <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", background: "#e5e7eb", color: "#888", fontSize: 14 }}>
            {banner.title || "Banner"}
          </div>
        )}
        {banner.title && (
          <div style={{
            position: "absolute", bottom: 0, left: 0, right: 0,
            background: "linear-gradient(transparent, rgba(0,0,0,0.55))",
            color: "#fff", padding: "12px 16px 10px", fontSize: 14, fontWeight: 600,
          }}>
            {banner.title}
          </div>
        )}
      </div>
      {banners.length > 1 && (
        <div style={{ display: "flex", justifyContent: "center", gap: 6, padding: "8px 0 6px" }}>
          {banners.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              style={{
                width: i === current ? 18 : 8, height: 8,
                borderRadius: 4, border: "none", cursor: "pointer", padding: 0,
                background: i === current ? "#C8152A" : "#d1d5db",
                transition: "all 0.3s",
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
